import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import authConfig from './authConfig';
import { getMuiTheme } from './theme';
import { getTenantConfig } from './theme/tenantConfigs';

import { ThemeProvider } from '@mui/material';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

const tenant = getTenantConfig();
const theme = getMuiTheme(tenant);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={authConfig.domain!}
      clientId={authConfig.clientId!}
      authorizationParams={{
        redirect_uri: authConfig.redirectUri
      }}
      cacheLocation={authConfig.cacheLocation}
      useRefreshTokens={authConfig.useRefreshTokens}
    >
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// Register SW
serviceWorkerRegistration.register();
